<template>
  <structured-text
    :data="content"
    :custom-rules="customRules"
  />
</template>

<script>
import { StructuredText, renderRule } from 'vue-datocms'
import { isParagraph, isSpan } from 'datocms-structured-text-utils'

export default {
  name: 'SustainabilitySubheading',

  components: {
    StructuredText
  },

  props: {
    content: {
      type: Object,
      required: true,
    },
    colour: {
      type: String,
      default: '',
    },
  },

  computed: {
    customRules() {
      const colour = this.colour
      const classList = this.$b('heading', { colour }).join(' ')

      return [
        renderRule(
          isParagraph,
          ({ adapter: { renderNode: h }, children, key }) => {
            return h(
              'h3',
              { key, tag: 'h3', size: 'h3', class: classList },
              children
            )
          }
        ),
        renderRule(isSpan, ({ adapter: { renderNode: h }, node, key }) => {
          if (node.marks && node?.marks.includes('highlight'))
            return h('span', { key, class: `${this.$b('block')}` }, node.value)
          return node.value
        }),
      ]
    },
  },
}
</script>

<style lang="postcss">
.SustainabilitySubheading__heading {
  @apply text-base md:text-lg
    normal-case
    m-0;

  &--colour-black {
    @apply text-off-black;
  }

  &--colour-grey {
    color: #757575;
  }

  &--colour-white {
    @apply text-white;
  }

  .SustainabilitySubheading__block {
    @apply mdMax:block md:ml-xxs;

    &:last-child {
      @apply mdMax:pt-xs;
    }
  }
}
</style>
